import React from "react";
import AuthLayout from "../Components/AuthPageLayout";
import SignUpForm from "../Components/SignUpForm";

function SignUp() {
  return (
    <>
      <AuthLayout>
        <SignUpForm />
      </AuthLayout>
    </>
  );
}


export default SignUp